<template>
  <el-dialog
    class="registrationManagement_batchReview_dialog"
    :visible.sync="dialogVisible"
    width="40%"
    :before-close="handleClose"
  >
    <el-button
      v-for="item in reviewButton"
      :key="item.key"
      :type="item.key === status ? 'primary' : 'info'"
      @click="changeStatus(item.key)"
    >
      {{ item.value }}
    </el-button>
    <el-form
      ref="form"
      :model="form"
      :rules="status === 1 || status === '' ? notRules : rules"
      :validate-on-rule-change="false"
    >
      <el-form-item
        prop="reason"
        :label="status === 1 || status === '' ? '原因（可不填）：' : '原因：'"
      >
        <el-input v-model="form.reason" type="textarea" :rows="4"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-row>
        <el-col :span="16" class="desc">
          <div>注 :</div>
          <div>1、审核不通过的学生将不能重新报名此课程。</div>
          <div>2、批量操作后不可逆，请谨慎操作！</div>
        </el-col>
        <el-col :span="8">
          <el-button type="primary" @click="batchReview">确 定</el-button>
          <el-button @click="handleClose">取 消</el-button>
        </el-col>
      </el-row>
    </span>
  </el-dialog>
</template>

<script>
import * as api from '@/api/index'
import * as api2 from '@/api/courseware/coursewareList'

export default {
  props: ['selectedList'],
  data() {
    return {
      dialogVisible: true,
      reviewButton: [
        {
          value: '审核通过',
          key: 1,
        },
        {
          value: '审核退回',
          key: 4,
        },
        {
          value: '审核不通过',
          key: 0,
        },
      ],
      status: 1,
      form: {
        reason: '',
      },
      notRules: {},
      rules: {
        reason: [{ required: true, message: '请输入原因', trigger: 'blur' }],
      },
      uName: '',
    }
  },
  computed: {
    getUId() {
      return localStorage.getItem('uid') 
    },
  },
  created() {
    this.getUserByUid()
  },
  methods: {
    getUserByUid() {
      api2.getUserByUid(this.getUId).then(({ data }) => {
        if (data.code === 100000) {
          this.uName = data.data.uname
        }
      })
    },
    changeStatus(status) {
      this.form.reason = ''
      this.$refs.form.clearValidate()
      this.status = status
    },
    batchReview() {
      console.log(this.status, 'status')
      if (this.status === '') {
        return this.$message.error('请选择审核方式')
      }
      this.$refs.form.validate(async (valid) => {
        if (!valid) {
          return
        }
        const selectedList = this.selectedList
        let obj = {
          ids: '',
          infoType: '',
          sIds: '',
          verifyStatus: this.status,
          uid: this.getUId,
          uName: this.uName,
          noPassReason: this.form.reason,
        }
        for (let i = 0; i < selectedList.length; i++) {
          obj.ids += selectedList[i].orderId + ','
          obj.infoType += selectedList[i].infoType + ','
          obj.sIds += selectedList[i].uid + ','
        }
        const data = await api.updateApproveStatus(obj)
        if (data.data.code === 100000) {
          this.$message({
            type: 'success',
            message: data.data.msg,
          })
          this.$emit('closeBatchReview', 'successs')
        } else {
          this.$message.error(data.data.msg)
        }
      })
    },
    handleClose() {
      this.$emit('closeBatchReview')
    },
  },
}
</script>

<style lang="scss" scoped>
.el-col {
  font-size: 16px;
}
</style>
<style lang="scss">
.registrationManagement_batchReview_dialog {
  .el-dialog {
    .el-dialog__footer {
      margin-top: -18px;
      .desc {
        margin-top: -20px;
        font-weight: 700;
        text-align: left;
        color: rgb(217, 0, 27);
      }
    }
  }
}
</style>